import React, { useEffect, useState, useRef, useCallback } from 'react';
import {
  NotificationType,
  useNotificationStore,
} from '../../store/storeNotifications';
import { getAPIErrorMessage } from '../../helpers/helpers';
import { MicrosoftService } from '../../service/MicrosoftService';
import { useStoreMicrosoftData } from '../../store/storeMicrosoftData';

const POLL_INTERVAL_MS = 1500;
const POLL_TIMEOUT_MS = 300000;

const ConnectToMicrosoft: React.FC = () => {
  const [isConnecting, setIsConnecting] = useState(false);
  const { setIsMicrosoftConnected } = useStoreMicrosoftData();
  const setNotification = useNotificationStore(state => state.setNotification);
  
  const pollIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const pollTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const loginErrorHandler = (err: any) => {
    setNotification({
      type: NotificationType.Error,
      message: getAPIErrorMessage(err as any),
    });
  };

  const connectionHandler = useCallback(async () => {
    if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
    if (pollTimeoutRef.current) clearTimeout(pollTimeoutRef.current);

    try {
      const response = await MicrosoftService.getInstallUrl();
      const url = response.installUrl;
      if (!url) {
        setNotification({
          type: NotificationType.Error,
          message: 'Could not load Microsoft connection URL.',
        });
        return;
      }
      window.open(url, 'microsoftIntegration', 'popup,width=500,height=600');
      setIsConnecting(true);

      pollTimeoutRef.current = setTimeout(() => {
        if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
        pollIntervalRef.current = null;
        pollTimeoutRef.current = null;
        setIsConnecting(false);
        setNotification({
          type: NotificationType.Error,
          message: 'Connection timed out. Please try again.',
        });
      }, POLL_TIMEOUT_MS);

      pollIntervalRef.current = setInterval(async () => {
        try {
          const statusRes = await MicrosoftService.getLinkStatus();
          const status = statusRes.data?.status;
          
          if (status === 'completed') {
            if (pollIntervalRef.current) {
              clearInterval(pollIntervalRef.current);
              pollIntervalRef.current = null;
            }
            if (pollTimeoutRef.current) {
              clearTimeout(pollTimeoutRef.current);
              pollTimeoutRef.current = null;
            }
            setIsMicrosoftConnected(true);
            setIsConnecting(false);
          }
        } catch {
        }
      }, POLL_INTERVAL_MS);
    } catch (err) {
      loginErrorHandler(err);
    }
  }, [setIsMicrosoftConnected, setNotification]);

  useEffect(() => {
    return () => {
      if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
      if (pollTimeoutRef.current) clearTimeout(pollTimeoutRef.current);
    };
  }, []);

  return (
    <span
      style={{
        fontSize: '14px',
        color: '#3650DE',
        fontWeight: 700,
        cursor: 'pointer',
      }}
      onClick={() => connectionHandler()}
    >
      {isConnecting ? 'Connecting...' : 'Click here'}
    </span>
  );
};

export default ConnectToMicrosoft;
